import React, { useState , useRef} from "react";
import { connect } from "react-redux";
import RelationshipLinkList from "../../../../../../id/common/lists/RelationshipLinkList";
import RadioGroup from 'devextreme-react/radio-group';
import { createStore } from 'devextreme-aspnet-data-nojquery';

function Contacts(props) {
    let accessToken = props.oidc.user.access_token;
    const dataGrid = useRef(null);
    let formFields = { ROWID: props.CustomerRowId };
    let masterType = "01";
    const[idMasterType, setIdMasterType] = useState("01");
    const idMasterTypes = [
        { id: "01", text: "Customer" },
        { id: "03", text: "Shipper" },
        { id: "02", text: "Consignee" }
    ];
    const dataSource = createStore({
            key: 'ROWID',
            loadParams:
            {
                IDMEMBERTYPE: function ()
                {
                    return "22";
                },
                IDMASTERTYPE: function ()
                {
                    return "";
                },
                R_IDMASTER : function ()
                {
                    return formFields.ROWID;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/id/RelationShipLink/GetRelationshipLinks`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }

        });

    return (
        <div>
            <fieldset className='col-fieldset' style={{ marginBottom: '5px' }} >
                <RadioGroup
                    items={idMasterTypes}
                    defaultValue="01"
                    value={idMasterType}
                    valueExpr="id"
                    displayExpr="text"
                    layout="horizontal"
                    onValueChanged={e => { 
                        setIdMasterType(e.value); 
                        masterType = e.value;
                        switch(e.value) 
                        { 
                            case "01": formFields = { ROWID: props.CustomerRowId == null || props.CustomerRowId == "" ? "00000000-0000-0000-0000-000000000000" : props.CustomerRowId } ; 
                            break; 
                            case "02": formFields = { ROWID: props.ConsigneeRowId == null || props.ConsigneeRowId == "" ? "00000000-0000-0000-0000-000000000000" : props.ConsigneeRowId } ; 
                            break; 
                            case "03": formFields = { ROWID: props.ShipperRowId == null || props.ShipperRowId == "" ? "00000000-0000-0000-0000-000000000000" : props.ShipperRowId } ; 
                            break; 
                        }  

                        if (dataGrid.current && dataGrid.current.instance) {
                            // dataGrid.current.instance().refresh();
                            dataGrid.current.instance().option("dataSource", dataSource);
                        }
                    }}
                />
            </fieldset>
            <RelationshipLinkList gridKey="3a49ac49-3256-4703-948d-67b9ba920efe" formFields={formFields} IdMemberType="22" IdMasterType="" LookupUrl="None" Editable={false} height="50vh" dataGrid={dataGrid}></RelationshipLinkList>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Contacts);
